"use strict";var _interopRequireDefault=require("@babel/runtime/helpers/interopRequireDefault");var _styledComponents=_interopRequireDefault(require("styled-components"));Object.defineProperty(exports,"__esModule",{value:!0}),exports.widthCheck=exports.Card=void 0;const Card=exports.Card=_styledComponents.default.div`
  .cardImage {
    border: none;
    border-radius: 8px;
    width: 318px;
    height: 188px;
    padding: 16px 16px 13px 16px;
    display: flex;
    flex-direction: column;
    background: #fff;
    border: 1px solid #ddd9d5;
  }

  .cardImage: hover,
  .cardImageMobile: hover{
    background:${a=>a?.fromDetailsPage?"":"#DDD9D5"};
    opacity:${a=>a?.fromDetailsPage?"":"0.8"};
  }
  
  .cardImageMobile{
    border: none;
    border-radius: 8px;
    width: 336px;
    height: 56px;
    justify-content:space-between;
    padding: 0px 8px 0px 8px;
    display: inline-flex;
    background: #fff;
    border: 1px solid #ddd9d5;
    align-items: center;
    box-sizing:border-box;
  }
  .cardContentContainer {
    width: 100%;
    padding: 0px 11px 16px 19px;
  }
  
  .arrow {
    border: 1px solid #c63939;
    border-width: 0 2px 2px 0;
    display: inline-block;
    padding: 3px;
  }
  
  .right {
    transform: rotate(-45deg);
    -webkit-transform: rotate(-45deg);
  }

  .trevipay{
    margin-left: 8px;
    font-weight: 600;
    font-size: 14px;
    line-height: 20px;
    display:flex;
    margin-right:auto;
  }

  .cardNumber {
    text-transform: lowercase;
    margin-left: 8px;
    font-weight: 600;
    font-size: 14px;
    line-height: 20px;
    display:flex;
    margin-right:auto;
    max-width: ${a=>widthCheck(a?.card)};
  }
  .email{
    white-space: nowrap;
    display: inline-block;
    text-overflow: ellipsis;
    overflow: hidden;
  }
  
  .fsaHsa{
    text-transform: uppercase;
  }
  .expiryDetails {
    margin-top: 8px;
  }

  .expired {
    margin-top: 8px;
  }

  .confirmBtn {
    color: #c63939;
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    margin-right:8px;
    display: flex;
    align-items:center;
  }

  .visaImage {
    margin-right: auto;
  }

  .visaLogo {
    width: 40px;
    height: 24px;
  }

  .holderName {
    font-size: 14px;
    line-height: 16px;
    font-style: normal;
  }
  .trevipayHolderName {
    font-size: 14px;
    line-height: 16px;
    font-style: normal;
    text-transform: lowercase;
  }

  .maskedNumber {
    font-weight: 300;
    font-size: 18px;
    line-height: 25px;
  }

  .expiryDate {
    margin-left: 3px;
  }

  .details {
    background-color: white;
    display: flex;
  }
  .top {
    justify-content: space-between;
    align-items: center;
    display: flex;
    padding-right: 8px;
  }
  .bottom {
    display: flex;
    flex-direction: column;
    justify-content: end;
    flex-grow: 1;
    font-weight: 400;
    font-size: 14px;
    line-height: 21px;
    text-transform: capitalize;
    word-break: break-all;
  }
`,widthCheck=a=>a.displayCVV||a.cardExpired?"180px":"210px";exports.widthCheck=widthCheck;